module.exports = `${require.publicPath}download-img02.64140f82.png`;